export const DELETE_CAROUSAL_IMAGE='DELETE_CAROUSAL_IMAGE';
export const FETCH_ALL_CAROUSAL_IMAGES='FETCH_ALL_CAROUSAL_IMAGES';
export const CREATE_CAROUSAL_IMAGE='CREATE_CAROUSAL_IMAGE';
export const START_LOADING_CAROUSAL_IMAGE='START_LOADING_CAROUSAL_IMAGE';
export const END_LOADING_CAROUSAL_IMAGE='END_LOADING_CAROUSAL_IMAGE';
